export default __webpack_public_path__ + "static/media/type_14_7.a8aa9fe6.svg";